import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { INewsDetails, INewsModel,INameExistModel } from '../Shared/interface';
import { catchError, map } from 'rxjs/operators';
import { IResponseModel } from '../Shared/models/ProspectModel';
import {AppService} from './app.service';

@Injectable({
    providedIn: 'root',
})
export class Newsservice {
    private baseURL = this.appService.config.apiBaseUrl;
    url;
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }


        getAllNews(): Observable<INewsDetails[]> {
            debugger;
            return this.http.get<INewsDetails[]>(
                `${this.baseURL}/News/GetAllNews`,
                { observe: 'response' })
                .pipe(
                    map(res => {
                        const packs = res.body as INewsDetails[];
                        return packs;
                    }),
                    catchError(this.handleError)
                );
        }

        getNewsdetails(newsId: number): Observable<INewsModel> {
            return this.http.get<INewsModel>(
                `${this.baseURL}/News/GetNews?newsId=${newsId}`,
                { observe: 'response' })
                .pipe(
                    map(res => {
                        const mrktDetail = res.body as INewsModel;
                        return mrktDetail;
                    }),
                    catchError(this.handleError)
                );

        }

        getNewsdetailsForOp(newsId: number): Observable<INewsModel> {
            return this.http.get<INewsModel>(
                `${this.baseURL}/News/GetNewsForOp?newsId=${newsId}`,
                { observe: 'response' })
                .pipe(
                    map(res => {
                        const mrktDetail = res.body as INewsModel;
                        return mrktDetail;
                    }),
                    catchError(this.handleError)
                );

        }

        getNewsNameExist(newsName: string): Observable<INameExistModel > {
            return this.http.get<INameExistModel >(
                `${this.baseURL}/News/IsNewsHeaderNameExist?newsName=${newsName}`,
                { observe: 'response' })
                .pipe(
                    map(result => {
                        const isExist = result.body as INameExistModel;
                        return isExist;
                    }
                    ),
                    catchError(this.handleError)
                );
        }
        savenews(merch: INewsModel): Observable<IResponseModel > {

            const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
            let url = '';
          //  const url = `${this.baseURL}/Marketing/SaveMarketingQuestion`;
            if (merch.NewsID === 0) {
                url = `${this.baseURL}/News/CreateNews`;
            }
            else {
                url = `${this.baseURL}/News/UpdateNews`;
            }
            return this.http.post<IResponseModel>(url, merch, options)
                .pipe(
                    map(res => {
                        return res;
                    }),
                    catchError(this.handleError)
                );
        }
        DeleteNews(mrktId: number) {
            const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

            return this.http.post<boolean>(`${this.baseURL}/News/DeleteNews?newsId=${mrktId}`, options);
        }




        private handleError(error: HttpErrorResponse) {
            console.log('server error:', error);
            if (error.error instanceof Error) {
                const errMessage = error.error.message;
                this.appinsights.logEvent(errMessage);
                return throwError(errMessage);
            }
            return throwError(error || 'Node.js server error');
        }

}
